import { message } from "antd";
import { useEffect, useMemo, useState } from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router";

const useAddressFromParams = (houseId) => {
	const [reloadPage, setReloadPage] = useState(false);

  const history = useHistory();
  const { allAddresses } = useSelector((store) => store.meterStore);
  
  const address = useMemo(
    () =>
      allAddresses.find((address) => Number(address.id) === Number(houseId)),
    [allAddresses, houseId]
  );

	useEffect(() => {
		if (reloadPage) {
			const timeoutId = setTimeout(() => {
				history.push("/Meters");
			}, 2000);
			return () => clearTimeout(timeoutId);
		}
	}, [reloadPage]);

  useEffect(() => {
    if (!address && allAddresses?.length) {
      message.error(
        "Такого адреса не существует, страница будет перезагружена"
      );
      setReloadPage(true);
    }
  }, [allAddresses, address]);

	return [address, !Boolean(allAddresses.length)];
};
export default useAddressFromParams;
